import { React, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { motion } from 'framer-motion';
import Table from 'react-bootstrap/Table';

import "./index.scss";

// import Button from "../../../../components/ui/Button";
import ProfileAvatar from "../../../../components/ui/ProfileAvatar";
import MonitorModal from "../../../../components/PostLogin/Monitor/MonitorModal";

import { formatNumber, getDomainImageUrl } from "../../../../utils/util";
import SkeletonLoader from "../../../ui/SkeletonLoader";


const MonitorListView = ({monitorList, isLoading}) => {

    const { t } = useTranslation();

    const navigate = useNavigate()

    const [showDeleteModal, setShowDeleteModal] = useState(false);

    // const handleShowModal = () => {
    //     setShowDeleteModal(true); // Open the modal
    // };

    const handleCloseModal = () => setShowDeleteModal(false);

    return (
        <Row>
            <Col md="12">
                {
                    isLoading ?
                        <div className="list-view-container users-list-view-table p-3">
                            <SkeletonLoader type={"line"} count={5} currentPage={"monitorList"} />
                        </div>                        
                    :
                    <div className="list-view-container users-list-view-table p-3">
                        <Table responsive="lg">
                            <thead>
                                <tr>
                                    <th>{t("monitor.monitorListView.domain")}</th>
                                    <th>{t("monitor.monitorListView.status")}</th>
                                    <th>{t("monitor.active")}</th>
                                    <th>{t("monitor.passive")}</th>
                                    <th>{t("monitor.monitorListView.monitorType")}</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    monitorList.results.length > 0 &&
                                    monitorList.results.map((data, index) => {
                                        return (
                                            <motion.tr
                                                key={index}
                                                initial={{ opacity: 0, y: 20 }}
                                                // whileInView={{ opacity: 1, y: 0 }}
                                                // viewport={{ once: true }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ duration: 0.4, delay: index * 0.1 }}
                                            >
                                                <td>
                                                    <ProfileAvatar type="profile" firstName={data?.monitor_domain?.domain} imageUrl={getDomainImageUrl(data?.monitor_domain)} />
                                                </td>
                                                <td>
                                                    <p>{data?.scan_type === "active" ? "Active Scan" : "Passive Scan"}</p>
                                                </td>
                                                <td>
                                                    <p>{formatNumber(data?.stats?.scans?.active)}</p>
                                                </td>
                                                <td>
                                                    <p>{formatNumber(data?.stats?.scans?.passive)}</p>
                                                </td>
                                                <td>
                                                    <p>{data.monitor_type}</p>
                                                </td>
                                                <td>
                                                    <div className='organization-list-view d-flex'>
                                                        {/* <Button buttonText={"Edit"}  onClick={handleShowModal} buttonType="primary" /> */}
                                                        <button
                                                        className="view-profile-btn"
                                                        onClick={()=>{navigate(`/monitor/details/${data.monitor_id}`)}}
                                                    >
                                                        Manage
                                                    </button>
                                                    </div>
                                                </td>
                                            </motion.tr>
                                        )
                                    })
                                }
                            </tbody>
                        </Table>
                    </div>
                }                
            </Col>
            <MonitorModal show={showDeleteModal} onHide={handleCloseModal} />
        </Row>
    )
}

export default MonitorListView;